import { Icon } from '@/components/icon';
import { tv } from '@/utils/styles';

const ShipmentMilestoneTransitEvent = () => {
  const { base, content, marker, progressBar } = styles();
  return (
    <div className={base()}>
      <div className={marker()}>
        <Icon name="vehicle-location" />
      </div>
      <span className={progressBar()} />
      <div className={content()}>In transit</div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'relative mb-2 flex items-end justify-between pb-4 leading-5',
    content: 'pl-10 text-baseSm font-medium text-lightBlue-500 md:pl-28',
    marker:
      'absolute -left-2 -top-0.5 z-4 ml-3 grid size-6 rotate-180 animate-light-blue-pulse place-items-center rounded-full bg-lightBlue-100 md:left-16 [&_svg]:size-4',
    icon: 'mr-3 size-4 shrink-0 translate-y-1 bg-white text-grey-300',
    progressBar:
      'absolute left-2 top-[18px] ml-[7px] h-full border-l border-dashed border-grey-300 last:-bottom-4 last:h-auto md:left-20',
  },
});

export { ShipmentMilestoneTransitEvent };
